import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';

import UserActions from 'store/reducers/User';
import SettingsActions from 'store/reducers/Settings';
import UserService from 'api/User';
import { handlePromise, storage } from 'utils';

const separator = '||||||';

const LoginByToken = ( {
  toggleLoading, loginUser, switchLanguage, match,
} ) => {
  const [isSubmitted, setIsSubmited] = useState( false );

  const submitForm = useCallback( async () => {
    const token = match && match.params && match.params.token ? match.params.token : null;
    if ( token ) {
      const tokenArray = token.split( separator );
      const t = tokenArray[0];
      const rt = tokenArray[1] ? tokenArray[1] : '';

      const loginData = {
        access_token: t,
        expires_in: 604800,
        token_type: 'bearer',
        scope: null,
        refresh_token: rt,
      };

      const error = ( errorMsg ) => {
        toggleLoading( false );
        return errorMsg || 'apiError';
      };
      storage.set( 'massphoning:token', t );

      toggleLoading( true );

      const [, userResponse, userData] = await handlePromise(
        UserService.getUser(),
      );
      if ( !userResponse.ok || !userData.roles ) {
        // || userData.roles.indexOf( 'ROLE_CUSTOMER_ADMIN' ) === -1 ) {
        storage.clear( 'massphoning:token' );
        return error( 'apiError' );
      }
      if ( userData.language ) {
        switchLanguage( {
          locale: userData.language === 'es' ? 'es' : 'en',
          name: userData.language === 'es' ? 'spanish' : 'english',
        } );
      }
      setTimeout( () => {
        loginUser( {
          ...loginData,
          email: userData.email,
          firstName: userData.firstName,
          lastName: userData.lastName,
          roles: userData.roles,
          credit: userData.credit,
        } );
        toggleLoading( false );
      } );
    }
  }, [loginUser, toggleLoading, switchLanguage, match] );

  useEffect( () => {
    if ( !isSubmitted ) {
      setIsSubmited( true );
      submitForm();
    }
  }, [submitForm, isSubmitted, setIsSubmited] );
  return ( <div style={{ height: '60vh' }} /> );
};

const mapDispatchToProps = ( {
  loginUser: UserActions.loginUser,
  toggleLoading: SettingsActions.toggleLoading,
  switchLanguage: SettingsActions.switchLanguage,
} );

export default connect( null, mapDispatchToProps )( LoginByToken );
